import React from "react";
import Login from "../login";

export function PageLoginOld() {
    return <Login old />;
}
